export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';

export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_CONFIG = 'LOAD_USER_CONFIG';

export const LOAD_USER_PERMISSIONS_SUCCESS  =  "LOAD_USER_PERMISSIONS_SUCCESS";







// WEBPACK FOOTER //
// ./src/actions/actionTypes.js